export default __webpack_public_path__ + "static/icon-visualization-720043305b14076cd1bd16e34fd8cbc4.svg";